import { Pipe, PipeTransform } from '@angular/core';
import { WorkstationLine } from 'src/app/models/workstationline';

@Pipe({
  name: 'prodScheduleWorkstationTime',
  standalone: true,
})
export class ProdScheduleWorkstationTimePipe implements PipeTransform {
  transform(
    orderId: number,
    workstationId: number,
    workstationLinesMap: { [orderId: number]: WorkstationLine[] },
    orders: any[]
  ): number | null {
    const lines = workstationLinesMap[orderId] || [];
    const line = lines.find(
      (wsLine) => Number(wsLine.workstation_id) === Number(workstationId)
    );
    if (!line) return null;
    const order = orders?.find((o) => o.id === orderId);
    if (!order) return null;
    return line.minutes;
  }
}
